module.exports = __webpack_public_path__ + "static/media/etapa3.bc28e087.jpg";